"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addTestAttribute = exports.TEST_ATTRIBUTE_KEY = void 0;
exports.TEST_ATTRIBUTE_KEY = 'data-testid';
const addTestAttribute = (testId) => ({
    [exports.TEST_ATTRIBUTE_KEY]: testId,
});
exports.addTestAttribute = addTestAttribute;
